const SnsProxy = require("clover/sns/SnsProxy");
const { join } = require("path");

let SnsMini = xClass("SnsMini", SnsProxy)

SnsMini.prototype.ctor = function() {
    this._adOff = false; // 广告功能是否关闭（配置）
    this._shareOff = false;  // 分享功能是否关闭（配置）
    this._closeMusicInAd = true;   // 是否需要在播放视频广告时关闭背景声音
    this._adDcName = ''  // 广告打点名

    this._isMusicOpenBeforeAd = false;  // 标识广告前是否播放音乐，只有_closeMusicInAd为true时才有用
    this.customAdInfo = null
    this.showNum = 0
}

SnsMini.prototype.initSdk = function (callback) {
    CfgManager.load("game")
    .then(()=> {
        let game = CfgManager.get("game")
        let adsOffList = game.watchad_off? game.watchad_off.split(","): [];
        let shareOffList = game.share_off? game.share_off.split(","): [];

        CfgManager.release("game");

        if (mini.supportMemoryWarning()) {
            mini.onMemoryWarning(res => {
                if (res) {
                    DCAssist.userTrack("low_memory", String(res.level), {"res": JSON.stringify(res)})
                }
            })
        }

        let platformName = mini.getPlatform();
        this._adOff = adsOffList.indexOf(platformName) >= 0;
        this._shareOff = shareOffList.indexOf(platformName) >= 0;

        callback();
    })
    .catch(err => {
        console.error("SnsMini init failed!", err);
        callback(err? err: new Error('SnsMini init failed!'));
    })
}

SnsMini.prototype.onLoadingComplete = function() {
    if (this.allowShare()) {
        this.initShare();
    }

    // if (this.allowAd()) {
    //     this.initAd();
    // }
}
SnsMini.prototype.onLoadingCompleteInitAd = function() {

    if (this.allowAd()) {
        this.initAd();
    }
}
SnsMini.prototype.initShare = function() {
    let param = this._packShareParam();
    mini.showShareMenu(param);
}

SnsMini.prototype.initAd = function() {
    mini.createRewardedVideoAd(this._translateAdPos("FailAdd1Step", true), handler(this, this.finishSaveByGridAd))  // 预创建广告
}

/**
 * 转译游戏广告位到平台广告位
 */
SnsMini.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    throw new Error('Please implements the method [_translateAdPos]!');
}

/**
 * 生成分享参数
 */
SnsMini.prototype._packShareParam = function() {
    throw new Error('Please implements the method! [_packShareParam]');
}

SnsMini.prototype.getSystemPlatfrom = function () {
    return mini.getOS() == MiniOS.IOS? SystemPlatform.IOS: SystemPlatform.Android;
}

/**
 * 是否允许使用广告
 */
SnsMini.prototype.allowAd = function() {
    return !this._adOff && mini.supportRewardVideo();
}

/**
 * 是否允许使用分享
 */
SnsMini.prototype.allowShare = function() {
    return !this._shareOff && mini.supportShare();
}


/**
 * 获取在快捷收藏里的配置名
 */
SnsMini.prototype.getShortcutConfigName = function() {
    return mini.getShortcutConfigName();
}

/**
 * 是否支持快捷方式进入游戏
 */
SnsMini.prototype.supportShortcut = function() {
     return mini.supportShortcut();
}
/**
 * 是否通过快捷方式进入游戏
 */
SnsMini.prototype.isFromShortcut = function (sceneValues) {
    let launchOptions = mini.getLaunchOptionsSync()
    let scene = launchOptions? launchOptions.scene: 0;
    if (!scene)
        return false;
    
    if (!sceneValues)
        sceneValues = mini.getShortcutSceneValues();
    return sceneValues && sceneValues.indexOf(scene.toString()) >= 0
}


/**
 * 广告是否拉取完毕可以播放
 */
SnsMini.prototype.isAdReady = function(adPos) {
    let ad = mini.createRewardedVideoAd(this._translateAdPos(adPos), handler(this, this.finishSaveByGridAd));
    return ad && ad.isLoaded;
}

/**
 * 预加载广告
 */
SnsMini.prototype.prepareAd = function(adPos = 0, useDefaultId = false, checkNum = -1) {
    let self = this;
    if (__DEBUG){
        cc.log("**************prepareAd**************, checkNum", checkNum)
    }

    var adId = this._translateAdPos(adPos, useDefaultId);
    cc.log("****AD id", adId);

    let saveFunc = function(callback){
        console.log("prepareAd saveFunc adPos", adPos);
        if (checkNum == -1 && (adPos == "GoldMatchAddStep" || 
                               adPos == "CoinMatchAddStep" || 
                               adPos == "CoinMatchFailAddStep" || 
                               adPos == "CoinMatchReset" ||
                               adPos == "MarketGetCash" || 
                               adPos == "CashNotEnough" || 
                               adPos == "LimitBlockColloctionAddTime" ||
                               adPos == "AdGoldTurn")){
            self.finishSaveByGoldModeAd(self.finishSaveByGridAd.bind(self, callback));
        }else{
            self.finishSaveByGridAd(callback);
        }
    }
    let ad = mini.createRewardedVideoAd(adId, saveFunc);

    if (ad == null) {
        return Promise.reject({ errMsg: getText("video.ad.error") })
    }


    return ad.load().catch(err=> {
        console.log(err)
        if (this.hasMoreRewardAdId() && checkNum != 0){
            if (checkNum < 0){
                this.setNextRewardAdId();
                return this.prepareAd(adPos, true, 0)
            }else{
                this.setNextRewardAdId();
                return this.prepareAd(adPos, true, checkNum-1)
            }
        }else{
            console.error(`${this._adDcName || 'snsMini'} loadRewardedVideoAd! err = ${err? err.errMsg: ''}`);
            if (this._adDcName)
                DCAssist.userTrack(this._adDcName, "noAds");
            if (window.logCenter) {
                logCenter.error(new Error(`${this._adDcName || 'snsMini'} prepareAd failed! err = ${err? err.errMsg: ''}`), 'AdError')
            }
            return Promise.reject({
                errMsg: getText("video.ad.error")
            }); 
        }   
    })
}

// 格子广告用记录看广告
SnsMini.prototype.finishSaveByGridAd = function(callback){
    console.log("adtask finishSaveByGridAd")
    let self = this
    var onSuccess = function(evt){
        if (callback){
            callback();
        }
        console.log("adtask finishSaveByGridAd onSuccess",self.adPos)
        self.recordTask()
    }
    var http = SaveShowVideoHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onSuccess);
    http.addEventListener(Events.kCancel, onSuccess);
    http.load();
    if (MetaManager.getInstance().gridAdConfig && MetaManager.getInstance().gridAdConfig.videoToday){
        MetaManager.getInstance().gridAdConfig.videoToday.push(Localhost.time());
    }
}

// 格子广告用记录看广告
SnsMini.prototype.finishSaveByGoldModeAd = function(callback){
    var onSuccess = function(evt){
        if (callback){
            callback();
        }
    }
    var http = SaveGoldModeAdHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onSuccess);
    http.addEventListener(Events.kCancel, onSuccess);
    http.load();
}

/**
 * 显示插屏广告用
 */
SnsMini.prototype.setNeedShowInterstitialAdName = function() {
    if (mini.supportInterstitialAd()) {
        console.warn('Please implements the method! [setNeedShowInterstitialAdName]', 'or return false in setNeedShowInterstitialAdName')
    }
    return false;
}

SnsMini.prototype.getNeedShowInterstitialAdName = function() {
    if (mini.supportInterstitialAd()) {
        console.warn('Please implements the method! [setNeedShowInterstitialAdName]', 'or return false in setNeedShowInterstitialAdName')
    }
    return false;
}

// 显示插屏广告
SnsMini.prototype.showInterstitialAd = function(adId, adName, closeCb, showToast = false, before_load_time){
    let self = this
    if (!before_load_time) before_load_time = 0
    // 插屏广告记录
    var saveInterstitialAd = function(){
        DCAssist.userTrack("inter_ad", "close", {"type":adName, "product_id":adId, "session":self.session});
        var http = SaveInterAdHttp.new();
        http.load();
        if (MetaManager.getInstance().interstitialAdConfig){
            if (MetaManager.getInstance().interstitialAdConfig.adToday == null || MetaManager.getInstance().interstitialAdConfig.adToday == undefined){
                MetaManager.getInstance().interstitialAdConfig.adToday = 0;
            }
            MetaManager.getInstance().interstitialAdConfig.adToday += 1;
        }
        cc.log("insertAD 正常显示处理回调  ")
        if (closeCb){
            closeCb();
        }
    }

    let ad = mini.createInterstitialAd({adUnitId:adId}, saveInterstitialAd);
    if (ad == null) {
        if (closeCb){
            closeCb();
        }
        return Promise.reject({ errMsg: getText("video.ad.error") })
    }
    // let cleanScheduler = ()=>{
    //     cc.log("insertAD cleanScheduler")
    //     cc.director.getScheduler().unscheduleScriptEntry(self._schedulerId_interstitial_ad)
    //     self._schedulerId_interstitial_ad = null
    // }
    // cleanScheduler()
    return ad.load()
    .then(()=> {
        console.log("adids 插屏", adId)
        // if (!ad.showed){
        //     ad.showed = true
            console.log("dc4ads inter_ad")
            let session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
            self.session = session
            let offset = new Date().getTime() - before_load_time
            DCAssist.userTrack("inter_ad", "show", {"type":"inter_levelsucceed", "product_id":adId, "session":self.session, "ad_time": offset});
            
        // }
        return ad.show();
        // setTimeout(()=>{
        // },10000)
    }, err=>{
        cc.log("showInterstitialAd err");
        cc.log(err, JSON.stringify(err));
        showToast && Toast.make(getText("video.ad.error"));
        if (closeCb){
            closeCb();
        }
    })
    .catch(err=>{
        cc.log(err, JSON.stringify(err));
        showToast && Toast.make(getText("video.ad.error"));
        if (closeCb){
            closeCb();
        }
    })
}
// 记录播放广告的开始时间
SnsMini.prototype.recordPlayADStartTime = function(){
    this.playADStartTime = new Date().getTime();
    cc.log("[AD]"," SnsMini recordPlayADStartTime this.playADStartTime ",this.playADStartTime);

},
// 获取观看广告的时间（以用户最后点击关闭时间为主）
SnsMini.prototype.getPlayADTime = function(){
    let curTime = new Date().getTime();
    let time = Math.ceil((curTime - this.playADStartTime)/1000);
    cc.log("[AD]"," SnsMini getPlayADTime time ",time);
    return time;
},
// 记录任务
SnsMini.prototype.recordTask = function(){
    let self = this
    console.log("adtask recordTask self.adPos",self.adPos)
    let adPos = self.adPos
    if (!adPos) {
        console.log("adtask recordTask adPos = null")
        return
    }
    // require("activity/AdTask/AdTaskLogic")

    // if (adPos == 0) {
    //     adPos = "AdStarDraw"
    // }
    AdTaskLogic.getInstance().finishAdTaskByAdPos(adPos)
    NewUserTaskManager.getInstance().tryCompleteTask(NewUserTaskManager.TASK_TYPE_ENUM.show_ad)
}
/**
 * 显示广告
 * @param checkNum 
 */
SnsMini.prototype.showAd = function(adPos = 0, useDefaultId = false, checkNum = -1, startShowCb,params) {
    let self = this;
    if (__DEBUG){
        cc.log("**************showAd**************adPos", adPos, "checkNum", checkNum)
    }
    if (!self.allowAd()) {
        return Promise.reject({ errMsg: getText("video.ad.error") })
    }
    if (adPos != 0){
        self.adPos = adPos
    }
    if (adPos == "AdStarDraw" || adPos == "AdStarDrawReset" || adPos == "PVPTicket") {
        adPos = 0
    }
    console.log("adtask showAd adPos = ", self.adPos)
    var adId = self._translateAdPos(adPos, useDefaultId);
    cc.log("[AD]"," SnsMini showAd adId ",adId);

    let saveFunc = function(callback){
        console.log("showAd saveFunc adPos", adPos);
        if (checkNum == -1 && (adPos == "GoldMatchAddStep" || 
                               adPos == "CoinMatchAddStep" || 
                               adPos == "CoinMatchFailAddStep" || 
                               adPos == "CoinMatchReset" ||
                               adPos == "MarketGetCash" || 
                               adPos == "CashNotEnough" || 
                               adPos == "LimitBlockColloctionAddTime" ||
                               adPos == "AdGoldTurn")){
            self.finishSaveByGoldModeAd(self.finishSaveByGridAd.bind(self, callback));
        }else{
            self.finishSaveByGridAd(callback);
        }
    }
    let skipAd = function() {
        Toast.make(getText("尊贵的特权玩家，已为您跳过广告啦~"))
        if (startShowCb){
            startShowCb();
        }
        self.recordTask() //权益卡玩家 跳过广告也算完成任务
        return Promise.resolve(true)
    }
    if (UserManager.getInstance().isHaveEquityMonthTicket()){
        return skipAd();
    }

    let buyTicketFail = function() {
        let ad = mini.createRewardedVideoAd(adId, saveFunc);
        if (ad == null) {
            return Promise.reject({ errMsg: getText("video.ad.error") })
        }
        self._isMusicOpenBeforeAd = false;
        if (self._closeMusicInAd) {
            self._isMusicOpenBeforeAd = MusicPlayer.getInstance().IsBackgroundMusicOpen
            if (self._isMusicOpenBeforeAd)
                MusicPlayer.getInstance().pauseBackgroundMusic()
        }
        return ad.load()
        .then(()=> {
            if (startShowCb){
                startShowCb();
            }
            self.recordPlayADStartTime();
            console.log("adids reward", self.adPos)
            DCAssist.dc4AdsShow(self.adPos,params) //广告位播放打点
            // window.logCenter && logCenter.error(new Error(`AdIdError adid=${ad.adPos} `), 'AdIdError');
            // console.log("[AD] record ids ad.adPos", ad.adPos)
            return ad.show();
        })
        .then((isEnd)=> {
            if (self._isMusicOpenBeforeAd) {
                MusicPlayer.getInstance().resumeBackgroundMusic();
                self._isMusicOpenBeforeAd = false;
            }
            // self.recordTask(adPos)
            
            return Promise.resolve(isEnd);
        })
        .catch(err=> {
            if (self._isMusicOpenBeforeAd) {
                MusicPlayer.getInstance().resumeBackgroundMusic();
                self._isMusicOpenBeforeAd = false;
            }
            if (self.hasMoreRewardAdId() && checkNum != 0){
                if (checkNum < 0){
                    self.setNextRewardAdId();
                    return self.showAd(adPos, true, 0)
                }else{
                    self.setNextRewardAdId();
                    return self.showAd(adPos, true, checkNum-1)
                }
            }else{
                console.error(`${self._adDcName || 'snsMini'} playRewardedVideoAd! err = ${err? err.errMsg: ''}`);
                if (self._adDcName)
                    DCAssist.userTrack(self._adDcName, "noAds");
                if (window.logCenter) {
                    logCenter.error(new Error(`${self._adDcName || 'snsMini'} showAd failed! err = ${err? err.errMsg: ''}`), 'AdError')
                }
                return Promise.reject({
                    errMsg: getText("video.ad.error")
                });
            }
        })
    }

    return new Promise((resolve, reject) => {
        UserManager.getInstance().isTodayFirstShowAd().then((first)=>{
            if(checkNum == -1 && first) {
                UserManager.getInstance().showTicketAd(() => {
                    skipAd().then((isEnd)=>{
                        resolve(isEnd);
                    })
                }, () => {
                    buyTicketFail().then((isEnd)=>{
                        resolve(isEnd);
                    }).catch((err)=>{
                        reject(err);
                    })
                }, self.adPos);
            }else {
                resolve(buyTicketFail());
            }  
        })
    })
}
/**
 * 是否还有可以用的广告id
 */
SnsMini.prototype.hasMoreRewardAdId = function(){
    console.warn("maybe need implements the method hasMoreRewardAdId");
    return false;
}
/**
 * 设置下一个广告id
 */
SnsMini.prototype.setNextRewardAdId = function(){
    console.warn("maybe need implements the method setNextRewardAdId");
    return null;
}

// 显示格子广告，暂时只有微信有
SnsMini.prototype.showGridAd = function(config){
    if (mini.createCustomAd){
        let gridAd = mini.createGridAd(config);
        console.log("#### gridAd: gridAd "+ gridAd)
        if (gridAd == null || gridAd == undefined){
            return Promise.reject({ errMsg: getText("video.ad.error") });
        }
        // mini.m_GridAd = gridAd
        return gridAd.show();
    }
    return Promise.reject({ errMsg: getText("video.ad.error") });
}

/**
 * 销毁格子广告
 */
SnsMini.prototype.destroyGridAd = function() {      
    if(mini.destroyGridAd){
        mini.destroyGridAd();
    }
}

SnsMini.prototype.hideGridAd = function(){
    if (mini.hideGridAd){
        mini.hideGridAd();
    }
}

//模板广告，暂时只有微信有
SnsMini.prototype.checkCustomAd = function(customAdName){
    let self = this

    console.log("@@@@ call check custom ad ", self.customAdInfo)

    //  检查分辨率比率
    var iphone6width = 375;
    var iphone6height = 667;
    if ((display.width / display.height) / (iphone6width / iphone6height) >= 1.02) {
         console.log("@@@@ 自定义广告分辨率不满足");
        return null;
    }

    if (!self.customAdInfo){
        console.log("@@@@ no custom ad info")
        return false
    }
    //检查平台是否配置了该广告位
    //if (!self.customAdInfo[customAdName]){
    //    console.log("@@@@ no this ad ", customAdName)
    //    return false
    //}

    //检查用户组是否开放当前广告位
    let userGroup = "0"
    if (self.customAdInfo.pay30day)
        userGroup = "1"
    //test only
    //userGroup = 0
    let userGroupAdList = self.customAdInfo[userGroup]
    let noLimitAdList = self.customAdInfo["-1"]
    if (!userGroupAdList && !noLimitAdList){
        console.log("@@@@ no user group list, curUserGroup ", userGroup)
        return false
    }
    let hasCurAd =  false
    if (userGroupAdList){
        for (let i = 0; i < userGroupAdList.length; ++i){
            console.log("@@@@ compare ", userGroupAdList[i], customAdName)
            if (userGroupAdList[i] == customAdName){
                hasCurAd = true
                break;
            }
        }
    }
    if (!hasCurAd && noLimitAdList){
        for (let i = 0; i < noLimitAdList.length; ++i){
            console.log("@@@@ compare ", noLimitAdList[i], customAdName)
            if (noLimitAdList[i] == customAdName){
                hasCurAd = true
                break;
            }
        }
    }
    if (!hasCurAd){
        console.log("@@@@ this user not in group ", userGroup)
        return false
    }

    //检查用户等级是否满足开放条件
    let curLvl = UserManager.getInstance().user.topLevelId
    if (curLvl < self.customAdInfo.minLvl || (curLvl > self.customAdInfo.maxLvl && self.customAdInfo.maxLvl != -1)){
        console.log("@@@@ this user not in right level range", curLvl)
        return false
    }

    //检查是否是活动时间    
    let curTime = Localhost.timeInSec()
    if (curTime > self.customAdInfo.endTime || curTime < self.customAdInfo.startTime){
        console.log("@@@@ this user not in right time", curTime)
        return false
    }

    //看广告小于一定次数
    if (self.customAdInfo.videoToday > self.customAdInfo.videoAdLimit){
        console.log("@@@@ this user not in right video ad", self.customAdInfo.videoToday)
        return false
    }

    console.log("@@@@ check custom ad success")
    return true
}
SnsMini.prototype.setInIslandScene = function (inIsland){
    let self = this
    self.inIsland = inIsland
}
SnsMini.prototype.tryShowHideCustomAdWhenPanelPop = function(isShow, ignoreScene, checkIsland){
    // 暂时去掉左下角广告
    return
    let self = this
    let scene = cc.Director.getInstance().getRunningScene();
    if (ignoreScene || (scene && scene.name === 'HomeScene')) {
        if (isShow){
            self.showNum += 1
            //if (reset){
                //console.log("@@@@ show custom ad num is reset to 1")
                //self.showNum = 1
            //}
            console.log("@@@@ try show custom ad ", self.showNum,self.activeCustomAd)
            //self.showcu    判断self.activeCustomAd.m_CustomAd 防止广告被消毁出错
            if (self.activeCustomAd && self.activeCustomAd.m_CustomAd && self.showNum > 0){
                self.activeCustomAd.show().then(()=>{  
                    console.log("adids customAd", self.activeAdId)
                    if (self.activeCustomAd && !self.activeCustomAd.showed){
                        self.activeCustomAd.showed = true
                        console.log("dc4ads @@@@ show dc ", self.activeAdId)
                        DCAssist.dc4CustomAdPromptShow(self.activeAdId)
                    }

                })
            }
        }else{
            if (checkIsland && self.inIsland){
                return
            }
            self.showNum -= 1
            console.log("@@@@ try hide custom ad ", self.showNum)
            if (self.showNum <= 0){
                //self.showNum = 0
                setTimeout(() => {
                    self.hideCustomAd()
                }, 200);
            }
        }
    }
}
SnsMini.prototype.showCustomAd = function(adConfig, customAdName, sceneName){
    let self = this
    self.activeCustomAd = null
    self.activeAdId = ""
    //self.showNum = 0
    if (mini.createCustomAd){
        var onSuccess = function(evt){
            self.customAdInfo = {}
            let videoLen = evt.data.videoToday.length
            self.customAdInfo.videoToday = 0
            let curTime = Localhost.timeInSec() * 1000
            console.log("@@@@ video list ", evt.data.videoToday)
            for (let i = 0; i < videoLen; ++i){
                if (evt.data.videoToday[i] != null){
                    if (curTime - evt.data.videoToday[i] <= 86400000){
                        self.customAdInfo.videoToday = videoLen - i
                        break
                    }
                }
            }
            self.customAdInfo.pay30day = 0
            if (evt.data.pay30day)
                self.customAdInfo.pay30day = 1
            
            if (self.customAdInfo != null && self.customAdInfo.maxLvl != null){
                showAd()
            }else{
                CfgManager.load("game").then( (dataMap)=>{
                    let config = dataMap.get("game")
                    //custom ad lvl range
                    self.customAdInfo.minLvl = config.custom_ad_min_level
                    self.customAdInfo.maxLvl = config.custom_ad_max_level
                    //custom ad video limit
                    self.customAdInfo.videoAdLimit = config.custom_ad_video_limit
                    //custom ad duration
                    self.customAdInfo.startTime = config.custom_ad_start_time
                    self.customAdInfo.endTime = config.custom_ad_end_time
                    //custom user group | format: "0:id1|id2"
                    if (config.custom_ad_usergroup){
                        let userList = config.custom_ad_usergroup
                        let userAdList = []
                        let adList = []
                        for (let i = 0; i < userList.length; ++i){
                            userAdList = userList[i].split(':')
                            let usrGroupID = userAdList[0].toString()
                            self.customAdInfo[usrGroupID] = []
                            adList = userAdList[1].split('|')
                            for (let j = 0; j < adList.length; ++j){
                                self.customAdInfo[usrGroupID].push(adList[j])
                            }
                        }
                    }
                    //custom id list | fromat: "wechatgame:id1|name1, id2|name2"
                    let customAdIDList = config.custom_ad_unitid
                    if (customAdIDList){
                        let platformList= []
                        let adList = []
                        for (let i = 0; i < customAdIDList.length; ++i){
                            platformList = customAdIDList[i].split(':')
                            self.customAdInfo[platformList[0]] = {}
                            adList = platformList[1].split(',')
                            for (let j = 0; j < adList.length; ++j){
                                let adInfo = adList[j].split('|')
                                self.customAdInfo[platformList[0]][adInfo[0]] = adInfo[1]
                            }
                        }
                    }
                    CfgManager.release("game")

                    console.log("@@@@ show ad info ", JSON.stringify(self.customAdInfo))
                    showAd()
                })
            }
        }

        var onFail = function(evt){
            cc.error(evt);
        }

        var showAd = function(){
            if (self.checkCustomAd(customAdName)){
                console.log("@@@@ call show ad")
                let curPlatform = mini.getPlatform()
                let adList = self.customAdInfo[curPlatform]
                if (!adList){
                    console.log("@@@@ cur platform has no custom ad")
                    return
                }
                let adId = adList[customAdName]
                if (!adId){
                    console.log("@@@@ ad name not right ", customAdName)
                    return
                }
                //巨量腾讯替换原生模板广告位
                let channelAdId = transAdIdForChannel("CustomAd")
                if (adId && channelAdId){
                    adId = channelAdId
                }
                // let channel = UserManager.getInstance().getUserAdChannel()
                // if (channel == AdChannel.OceanEngine){
                //     adId = "adunit-1ebc11aa781f154b"
                // }else if (channel == AdChannel.Tencent){
                //     adId = "adunit-6a84b8f4bb3804e8"
                // }

                adConfig.adUnitId = adId
                console.log("@@@@ create custom ad ", JSON.stringify(adConfig))
                let customAd = mini.createCustomAd(adConfig);
                if (customAd == null || customAd == undefined){
                    console.log("@@@@ show ad failed ", customAd)
                    return
                }
                self.activeCustomAd = customAd
                self.activeAdId = adId
                //self.showNum = 1
                let callShow = true
                if (customAdName == "custom_homepage" && (sceneName != "HomeScene" && sceneName != "PreloadScene")){
                    callShow =  false
                }
                if (self.showNum <= 0){
                    callShow = false
                }
                if (callShow){
                    customAd.show().then(()=>{
                        //self.showNum = 1
                        console.log("adids customAd", self.activeAdId)
                        if (!customAd.showed){
                            customAd.showed = true
                            console.log("dc4ads @@@@ show dc ", adId)
                            DCAssist.dc4CustomAdPromptShow(adId)
                        }
    

                        //DCAssist.dc4User101("wx_promotion", "show", {channel_id:adId})
                    });
                }else{
                    //NOTE:新手教程进入gamescene 跳过了 minihomescene的 init那次show
                    //self.showNum = 2
                }
            }
        }

        var http = GetGridBannerConditionHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load();
    }
}

SnsMini.prototype.destroyCustomAd = function() {        
    if(mini.destroyCustomAd){
        mini.destroyCustomAd();
    }
}

SnsMini.prototype.hideCustomAd = function(){
    if (mini.hideCustomAd){
        return mini.hideCustomAd();
    }

    return Promise.resolve()
}

/**
 * 是否允许开启Pvp
 */
SnsMini.prototype.allowPvp = function() {
    return false;
}

/**
 * 是否允许开启Banner广告
 */
SnsMini.prototype.allowBannerAd = function (bannerPos, bannerData) {
    return mini.supportBannerAd(bannerPos, bannerData);
}

/**
 * 加载广告
 */
SnsMini.prototype.loadBannerAd = function (panel, bannerData, pos = 0, onLoadCallback, onFailCallback) {
    let ad = mini.createBannerAd(pos, panel, bannerData);

    if (ad == null) {
        console.log("CreateBannerAdFailed")
        //  Banner广告加载失败后什么都不播放
        if (onFailCallback) {
            onFailCallback()
        }
        return null;
    } else {
        console.log("CreateBannerAdSucess")
        if (ad.isLoaded) {
            console.log("BannerAd load finish，show directly");
            if (onLoadCallback) {
                onLoadCallback(ad)
            }
        } else {
            console.log("BannerAd not loaded,waitting for load")
            ad.onLoad(()=>{
                console.log("BannerAd load finish，begin show");
                if (onLoadCallback) {
                    onLoadCallback(ad)
                }
            })
        }
        return ad;
    }
}

/**
 * 关闭广告
 */
SnsMini.prototype.hideBannerAd = function (isDc, adShowSession) {
    
    if (window.mini && mini.supportBannerAd(true)){
        mini.hideBannerAd(isDc? (panel, adPos)=> {
            DCAssist.dc4BannerAdClose(panel, adPos, adShowSession);
        }: null);
    }
    //let ad = mini.getBannerAd();

    //if (ad) {
    //    console.log("hide banner");
    //    ad.hide(isDc);
        //if (ad.isShow) {
        //    DCAssist.dc4BannerAdClose(panel, adPos);
        //}
    //}
}

SnsMini.prototype.getShareLink = function (srcapp) {
    let data = { srcapp: srcapp }
    return this.getShareLinkStr(data);
}

SnsMini.prototype.getShareLinkStr = function (data) {
    data = data ? data : {}
    data['inviteCode'] = UserManager.getInstance().getUserRef().uid
    //添加ip屏蔽信息
    let ipRegionLimit = UserManager.getInstance().getUserExtendRef().ipRegionLimit
    if (ipRegionLimit){
        data['ipRegionLimit'] = JSON.stringify(ipRegionLimit)
    }
    var query = ''
    for (var i in data) {
        query += i + "=" + HeDisplayUtil.urlEncode(data[i]) + "&"
    }

    return query.substr(0, query.length - 1)
}
/**
 * 是否可以发送定向分享
 */
SnsMini.prototype.supportShareMessageToFriend = function () {
    return mini.supportShareMessageToFriend();
}

SnsMini.prototype.getNetworkType = function (callback) {
    if (mini.supportNetStatus()) {
        mini.getNetworkType({
            success (res) {
                callback(res.networkType);
            },
            fail () {
                callback(-1);
            }
        })
    } else {
        callback(-1);
    }
}

SnsMini.prototype.getPlatformName = function () {
    return mini.getPlatform();
}

/**
 * 检查是否断网
 */
SnsMini.prototype.checkNetwork = function (successCallback, failcallback) {
    // return mini.getPlatform();
    if (window.mini && mini.supportNetStatus()) {
        mini.getNetworkType({
            success (res) {
                networkType = res.networkType;
                if (networkType == "none" && failcallback ){
                    failcallback()
                }else{
                    successCallback()
                }
            },
            fail () {
                failcallback()
            }
        })
    }else{
        successCallback()
    }
}

SnsMini.prototype.supportCustomerService = function () {
    return mini.supportCustomerService();
}

SnsMini.prototype.getFontNameByTTF = function (url) {

    if (window.mini && mini.loadFont){
        console.log("getFontNameByTTF", cc.loader.getUrl(mini.env.USER_DATA_PATH, url), mini.loadFont(cc.loader.getUrl(mini.env.USER_DATA_PATH, url)))
        return mini.loadFont(cc.loader.getUrl(mini.env.USER_DATA_PATH, url))
    }
}
module.exports = SnsMini